import { useNavigate, useSearchParams } from 'react-router-dom';
import '../App.css';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { loadCampaign, patchCampaign, getCampaignBalanceE6 } from '../QueryCampaign';

function CampaignBudget({ campaign_id }) {
    const navigate = useNavigate();
    const e6 = 100000;

    const [t, setT] = useState(0);
    const [campaignBalanceE6, setCampaignBalanceE6] = useState(0);
    const [maxPricePerSecondE6, setMaxPricePerSecondE6] = useState(0);

    useEffect(
        () => {
            loadCampaign(campaign_id).then(
                (response) => setMaxPricePerSecondE6(
                    response.data.max_price_per_second_e6,
                )
            ).catch(
                (error) => navigate('/')
            )

        },
        [],
    )

    useEffect(
        () => {
            getCampaignBalanceE6(campaign_id).then(
                (response) => {
                    setCampaignBalanceE6(response.data.balance);
                }
            ).catch(
                (error) => {
                    navigate('/');
                }
            )
            setTimeout(
                () => {
                    setT(t + 1);
                },
                2000,
            )
        },
        [t],
    );

    return (
        <div align='center'>
            <div className='standard-box3'>
                <div>
                    Remaining Funds
                </div>
                <h3>
                    {campaignBalanceE6 / e6} EUR
                </h3>
            </div>
            <div className='standard-box3'>
                <Button
                    severity='success'
                    label='Allocate Budget'
                    size='small'
                    onClick={
                        () => {
                            navigate(`/campaign/budget/allocate/?campaign_id=${campaign_id}`);
                        }
                    }
                />
            </div>
            <div className='standard-box3'>
                <div>
                    Maximum price per second:
                </div>
                <div
                    style={{
                        marginTop: '1em',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                    }}>
                    <InputText
                        value={maxPricePerSecondE6}
                        onChange={
                            (e) => {
                                setMaxPricePerSecondE6(e.target.value)
                            }
                        }
                        className='text-input1'
                    />
                    <div style={{ marginLeft: '0.2em' }}>
                        <i className="pi pi-times" style={{ fontSize: '1.5rem' }} />
                    </div>
                    <h2 style={{ marginLeft: '0.2em' }}>
                        {1 / e6}
                    </h2>
                </div>
                <div>
                    <div style={{ marginLeft: '0.2em' }}>
                        = {maxPricePerSecondE6 / e6} EUR/second
                    </div>
                </div>
            </div>
            <div className='standard-box3'>
                <div style={{ marginTop: '1em' }}>
                    <div>
                        {maxPricePerSecondE6 / e6} EUR will be the maximum price paid per second of this ad.
                    </div>
                </div>
            </div>
            <div className='standard-box3'>
                <Button
                    label='Save'
                    severity='success'
                    size='small'
                    onClick={
                        () => {
                            patchCampaign(
                                campaign_id,
                                {
                                    max_price_per_second_e6: maxPricePerSecondE6,
                                }
                            ).then(
                                (response) => {
                                    navigate('/campaigns/');
                                }
                            ).catch(
                                (error) => navigate('/')
                            )
                        }
                    }
                />
            </div>
        </div>
    );
}

export default CampaignBudget;